<template>

  <div>
    <b-modal
      size="xl"
      ok-only
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <div class="d-flex align-items-center justify-content-center">
        <img :src="require(`@/assets/img/page/${img}.png`)" width="100%">
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  
  data() {
    return {
      loading: false,
      open: false,
      img: "",
      baseUrl: "@/assets/img/page/"
    };
  },

  methods: {
    toggleOpen({linkImg = ""}) {
      this.open = !this.open;
      this.img = linkImg
    },
  },
};
</script>